import { IOrgUser, UserService } from 'src/app/services/user.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, Input, ElementRef } from '@angular/core';
import { EvidencePayloadType, EvidenceService, EvidenceType } from 'src/app/services/evidence.service';
import { take, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { generate, Subject, pipe, Observable } from 'rxjs';
import { LearningService } from 'src/app/services/learning.service';
import * as dayjs from 'dayjs';
import { AnalyticsService, PAGE_CONTEXT_TYPES } from 'src/app/services/analytics.service';
import { Router } from '@angular/router';
import { AddEvidenceComponent } from '../add-evidence-form/add-evidence.component';
import { SidePanelEvidenceSection } from '../../linked-learning-record/side-panel-learning-record-section/side-panel-evidence-section/side-panel-evidence-section.component';
import { StaffLinkDisplayComponent } from '../../staff-link-display/staff-link-display.component';
import { SharedSidebarComponent } from '../../shared-sidebar/shared-sidebar.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { NgIf, NgFor } from '@angular/common';
import { UIStreamlineIconComponent } from '@ui/streamline-icon/ui-streamline-icon.component';
import { DownloadCertificateButtonComponent } from '@components/download-certificate/download-certificate.component';



// This feature is deprecated.
@Component({
    templateUrl: 'shared-evidence-cell.component.html',
    styleUrls: ['shared-evidence-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [NgIf, NgbTooltip, SharedSidebarComponent, StaffLinkDisplayComponent, NgFor, SidePanelEvidenceSection, AddEvidenceComponent, UIStreamlineIconComponent, DownloadCertificateButtonComponent]
})

export class SharedEvidenceCellComponent implements OnInit, OnDestroy {
  @ViewChild('appSharedSidebar', { static: true }) appSharedSidebar;
  @Input() rowData;
  @Input() value;
  private _destory$ = new Subject<void>();
  isLoading = true;
  activity: any;
  user: IOrgUser;
  rawSource;
  evidences: EvidenceType[];
  hasAddEvidenceSection = false;
  evidenceFormValue: EvidencePayloadType;
  isInternalRecord = false;
  constructor(
    private evidenceService: EvidenceService,
    private toaster: ToastrService,
    private _cdr: ChangeDetectorRef,
    private learningService: LearningService,
    private analytics: AnalyticsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.activity = this.rowData;
    this.isInternalRecord = this.activity?.recordType === "Internal Record" ? true : false;
    this.user = this.rowData.orgUser;
    this.evidences = this.rowData.detail.notes ? this.rowData.detail.notes.sort((a, b) => {
      return dayjs(a.addedDate).diff(dayjs(b.addedDate))
    }) : [];

    this.evidenceService.recordsDataRefresh.pipe(takeUntil(this._destory$)).subscribe(
      orgActivityID => {
        if (orgActivityID === this.rowData.activityID) {
          this.isLoading = true;
          this.generateSidebarData();
          this.evidenceService.recordsDataRefresh.next(false);
          this._cdr.detectChanges();
        }
      }
    );
  }

  openSidepanel() {
    this.appSharedSidebar.toggleShowSidebar();
    if (this.isLoading) {
      this.generateSidebarData();
    }
  }

  generateSidebarData() {
    let activity$: Observable<any>;
    const isOrgActivity = !!this.rowData.completion?.orgActivityID;
    if (isOrgActivity) {
      activity$ = this.learningService.fetchActivity(this.rowData.orgUser?.userID, this.rowData.activityID, true);
    } else {
      activity$ = this.learningService.fetchOrgActivity(this.rowData.orgUser?.userID, this.rowData.activityID, true);
    }
    activity$.pipe(takeUntil(this._destory$)).subscribe((activity) => {
      this.activity.detail = activity.detail;
      this.evidences = this.rowData.detail.notes ? this.rowData.detail.notes.sort((a, b) => {
        return dayjs(a.addedDate).diff(dayjs(b.addedDate))
      }) : [];
      this.isLoading = false;
      this.cancel();
      this._cdr.detectChanges();
    })
  }

  addEvidence(e) {
    if (e) {
      this.evidenceService.addEvidenceToOrgActivity(this.rowData.activityID, this.rowData.userID, this.evidenceFormValue).subscribe(
        () => {
          this.toaster.success('Evidence successfully added');
          this.generateSidebarData();
          const context = this.analytics.getContext(this.router.url);
          this.analytics.track('L-record-evidence_added', {
            context: context,
            notes: !!this.evidenceFormValue.note,
            weblink: !!this.evidenceFormValue.links[0]?.link,
            ...(context === 'reporting' ? { reportName: this.evidenceService.getEventReportName() } : {})
          })
        },
        (error) => {
          this.toaster.error('Error: ', error);
        }
      )
    }
  }

  cancel() {
    this.hasAddEvidenceSection = false;
  }

  ngOnDestroy(): void {
    this._destory$.next();
    this._destory$.complete();
  }

  showAddSection() {
    this.hasAddEvidenceSection = true;
    // scroll to the Bottom of the container
    this._cdr.detectChanges();
    this.scrollToBottom();
  }

  scrollToBottom() {
    let element = document.getElementById('add-evidence-section-container');
    element.scrollIntoView(false);
  }

  get hasEvidences() {
    return !!Object.keys(this.evidences || {}).length;
  }

  get complianceStatusBadgeStyle() {
    switch (this.rowData.status) {
      case 'Completed': return 'badge-success';
      case 'Done': return 'badge-success';
      default: return 'badge-light';
    }
  }
}
